import { numberToPrettyString } from '@cian/utils';
import { IOfferCard } from '../../../types';

export function getSalePrice(offerCard: IOfferCard): string {
  const formattedPrice = numberToPrettyString(offerCard.bargainTerms.priceRur);

  return `${formattedPrice}\u00A0₽`;
}
